import { useTranslation } from 'next-i18next';
import { FC, useMemo } from 'react';

import { GetFavoriteUsersResponse } from '@/apis/aniftyBackend/creations/userFavorite/getFavoriteUsers';
import MarketplaceCreatorCard from '@/components/MarketplaceCreatorCard.tsx';
import routes from '@/config/routes';
import createMiddleEllipsis from '@/utils/createMiddleEllipsis';

export type FavoriteUserItemProps = {
  favoriteUser: GetFavoriteUsersResponse['favoriteUsers'][number];
};
const FavoriteUserItem: FC<FavoriteUserItemProps> = ({ favoriteUser }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const creatorName = useMemo(
    () =>
      createMiddleEllipsis(
        language === 'ja' && favoriteUser.displayNameJA
          ? favoriteUser.displayNameJA
          : favoriteUser.displayName
      ),
    [language, favoriteUser.displayNameJA, favoriteUser.displayName]
  );

  return (
    <MarketplaceCreatorCard
      link={
        favoriteUser.userName
          ? routes.creatorDetail(favoriteUser.userName)
          : routes.myPage(favoriteUser.userID)
      }
      creatorName={creatorName}
      creatorProfileImageUrl={favoriteUser.photoURL}
      userID={favoriteUser.userID}
      creations={
        favoriteUser.isCreator
          ? favoriteUser.createdCreations.map((c) => ({
              ImageUrl: c.imageURL,
            }))
          : favoriteUser.collectedCreations.map((c) => ({
              AniftyToken: { ImageUrl: c.imageURL },
            }))
      }
      isCreator={favoriteUser.isCreator}
    />
  );
};

export default FavoriteUserItem;
